import { useTranslation } from "../state/i18n";
import Layout from "./Layout";
import Section from "./Section";
import moreappBrandIcon from "../assets/moreapp-icon-brand.svg";
import SeparatorLine from "../components/SeparatorLine";
import { TextButton } from "../components/button/Button";
import { useAuthDispatch } from "../state/auth";
import { useLocation, useNavigate } from "@solidjs/router";

const RootPage = () => {
  const { t } = useTranslation();
  const { login } = useAuthDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Layout>
      <Section centerOnMobile fullHeight={false}>
        <div class="w-full mobile:p-6">
          <img src={moreappBrandIcon} alt={t(($) => $.MOREAPP_LOGO_IMG_ALT)} class="mx-auto mb-10 size-12" />
          <h1 class="mb-10 text-center text-header-3xl text-primary">{t(($) => $.ROOT_PAGE_TITLE)}</h1>
          <div class="flex w-full flex-col gap-y-6">
            <TextButton
              block
              variant="primary"
              text={t(($) => $.ROOT_PAGE_LOGIN_BUTTON_LABEL)}
              onClick={() => login(location.pathname)}
            />
            <div class="flex h-5 w-full items-center gap-x-3">
              <SeparatorLine class="w-full" />
              <span class="text-secondary">{t(($) => $.ROOT_PAGE_ACTION_DIVIDER_LABEL)} </span>
              <SeparatorLine class="w-full" />
            </div>
            <TextButton
              block
              variant="secondary"
              text={t(($) => $.ROOT_PAGE_SIGN_UP_BUTTON_LABEL)}
              onClick={() => navigate("/signup")}
            />
          </div>
        </div>
      </Section>
    </Layout>
  );
};

export default RootPage;
